import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { withProfiling } from '../../../self-measurements';
import { ViewportUpdateClassifier } from './ViewportUpdateClassifier';
var legacyIgnoreReasons = ['image', 'ssr-hydration', 'editor-lazy-node-view', 'editor-container-mutation'];
export var FY25_01Classifier = /*#__PURE__*/function (_ViewportUpdateClassi) {
  function FY25_01Classifier() {
    var _this;
    _classCallCheck(this, FY25_01Classifier);
    _this = _callSuper(this, FY25_01Classifier);
    _defineProperty(_this, "revision", 'fy25.01');
    _defineProperty(_this, "types", ['html', 'text']);
    _defineProperty(_this, "filters", [{
      name: 'default-ignore-reasons',
      filter: function filter(_ref) {
        var type = _ref.type,
          ignoreReason = _ref.ignoreReason;
        return !ignoreReason || !legacyIgnoreReasons.includes(ignoreReason);
      }
    }]);
    _this.mergeConfig();
    _this.VCCalculationMethod = withProfiling(_this.VCCalculationMethod.bind(_this), ['vc']);
    return _this;
  }
  _inherits(FY25_01Classifier, _ViewportUpdateClassi);
  return _createClass(FY25_01Classifier, [{
    key: "VCCalculationMethod",
    value: function VCCalculationMethod(_ref2) {
      var VCParts = _ref2.VCParts,
        entries = _ref2.entries,
        totalPainted = _ref2.totalPainted,
        componentsLog = _ref2.componentsLog;
      var VC = {};
      var VCBox = {};
      entries.reduce(function () {
        var acc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var v = arguments.length > 1 ? arguments[1] : undefined;
        var VCRatio = v[1] / totalPainted + acc;
        var time = v[0];

        // @todo apply fix to include small changes into accumulator
        var preciseCurrRatio = Math.round(100 * (v[1] / totalPainted));
        var preciseAccRatio = Math.round(acc * 100);
        VCRatio = (preciseCurrRatio + preciseAccRatio) / 100;
        VCParts.forEach(function (value) {
          if ((VC[value] === null || VC[value] === undefined) && VCRatio >= value / 100) {
            var _componentsLog$time;
            VC[value] = time;
            VCBox[value] = new Set();
            (_componentsLog$time = componentsLog[time]) === null || _componentsLog$time === void 0 || _componentsLog$time.forEach(function (v) {
              var _VCBox$value;
              return (_VCBox$value = VCBox[value]) === null || _VCBox$value === void 0 ? void 0 : _VCBox$value.add(v.targetName);
            });
          }
        });
        return VCRatio;
      }, 0);
      return {
        VC: VC,
        VCBox: VCBox
      };
    }
  }]);
}(ViewportUpdateClassifier);
export var revFY25_01Classifier = new FY25_01Classifier();